import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "new-tab",
  "use": "new-tab-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 1024 1024\" id=\"new-tab\">\n<path d=\"M833.748 98.34h-275.792v-91.94h459.644v459.644h-91.94v-275.792l-459.644 459.644-91.94-91.94 459.644-459.644zM374.104 98.34v91.94h-275.792v735.408h735.408v-275.792h91.94v276.196c0 50.547-41.894 91.508-91.508 91.508h-736.271c-50.547 0-91.508-41.894-91.508-91.508v-736.271c0-50.547 41.894-91.508 91.508-91.508h276.196z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol